var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[_vm.currentFieldIsInvalid ? `${_vm.main_class} valid-error` : _vm.main_class]},[_c('q-checkbox',{attrs:{"dark":"","disable":_vm.disabled,"label":_vm.label,"id":_vm.name},model:{value:(_vm.currentField),callback:function ($$v) {_vm.currentField=$$v},expression:"currentField"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }